export function getChangePasswordErrorDescription(reason) {
  switch (reason) {
  case 'PASSWORD_DOESNT_MATCH':
    return 'Old Password Doesn’t Match';
  case '"PASSWORD_CANT_BE_SAME':
    return 'New password cannot be the same as old password';
  case '"PASSWORD_INVALID':
    return 'Password is invalid';
  default:
    return 'Something went wrong';
  }
}



// WEBPACK FOOTER //
// ./src/helpers/errorDescriptions.js